import { SideNavCategory } from '../../../components/side-nav';
import {
  fetchSavedReports,
  fetchRecentReports,
  SavedReport,
  RecentReport,
} from '../../../api';

const buildMyReportCategory = async (
  clientId: number,
): Promise<SideNavCategory<unknown>> => {
  const category: SideNavCategory<unknown> = {
    name: 'My Reports',
    key: 'My Reports',
    items: [],
  } as SideNavCategory<unknown>;

  const [savedReports, recentReports] = await Promise.all([
    fetchSavedReports(clientId),
    fetchRecentReports(clientId),
  ]);

  const savedCategory: SideNavCategory<SavedReport> = {
    name: 'Saved',
    key: 'Saved',
    items: [],
    typeName: 'SavedReport',
  } as SideNavCategory<SavedReport>;

  savedReports.forEach((e) => {
    savedCategory.items.push({
      name: e.reportName,
      key: e.id.toString(),
      tag: e,
      typeName: 'SavedReport',
    });
  });

  const recentCategory: SideNavCategory<RecentReport> = {
    name: 'Recents',
    key: 'Recents',
    items: [],
    typeName: 'SavedReport',
  } as SideNavCategory<RecentReport>;

  recentReports.forEach((e) => {
    recentCategory.items.push({
      name: e.taskName,
      preLocalizedName: e.preLocalizedTaskName,
      key: e.taskId.toString(),
      tag: { ...e, type: 'Recents' },
      typeName: 'RecentReport',
      parent: recentCategory,
    });
  });

  category.items.push(recentCategory);
  category.items.push(savedCategory);

  return category;
};

export { buildMyReportCategory };
